import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { vAPIURL, vGlobalDateNow } from '../../Global';
import axios from 'axios';
import toastr from 'toastr';
import format from 'date-fns/format';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(...registerables )

const BookingVsDeposit = () => {
	const [ Loading, setLoading ] = useState( false )
	const [ DataTemp, SetDataTemp ] = useState( [] );
	const date = new Date( vGlobalDateNow );

	let vNumberFormat = new Intl.NumberFormat(
		'en-US'
		, {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
		}
	)

	const GetBookingVsDepositData = async() => {
		setLoading( true );
		let vStatus = 1;
		let vMessage = [];

		try{
			const vURL = vAPIURL + "/Golf/Main/BookingVsDeposit/Dev";
			const vData = {
				Action: {
					Value: "Search"
				},
				Input: {
					Date: {
						Value: format( date, 'dd-MMM-yyyy' ),
					},
				},
			};
			const vConfig = {
				headers: {
					"Content-Type": "application/json"
					, Authentication: `${localStorage.getItem("Authentication")}`
				}
			}
			await axios
				.post( vURL, vData, vConfig )
				.then(
					( vResponse ) => {
						vStatus = vResponse.data.Status;

						for( let i = 0; i < vResponse.data.Message.length; i++ ){
							vMessage.push( vResponse.data.Message[ i ] );
						}

						if( vStatus === 1 ){
							SetDataTemp( vResponse.data.Output.Result )
						}
					}
				)
				.catch(
					( vError ) => {
						vStatus = 2;
						vMessage.push( "Error" );
					}
				)
		}catch( vError ){
			vStatus = 2;
			vMessage.push( "Error" );
		}

		if( vMessage.length > 0 ){
			if( vStatus === 1 ){
				//toastr.success( vMessage.join( "</br>" ) );
			}
			else{
				toastr.error( vMessage.join( "</br>" ) );
			}
		}
		setLoading( false );
	}

	let ChartData = {
		labels: DataTemp.map( Value => Value.Date ),
		datasets: [
			{
				label: 'BOOKING'
				, data: DataTemp.map( Value => Value.Booking )
				, backgroundColor: '#4472C5'
				, hoverBackgroundColor: '#6288cf'
				, borderColor: '#4472C5'
				, hoverBorderColor: '#6288cf'
				, borderWidth: 1
				, stack: 1
				, order: 1
			}
			,{
				label: 'Protected Pax'
				, data: DataTemp.map( Value => Value.ProtectedPax )
				, backgroundColor: '#ED7E30'
				, borderColor: 'rgb(236, 131, 45)'
				, hoverBackgroundColor: 'rgb(255, 197, 149)'
				, hoverBorderColor: 'rgb(255, 197, 149)'
				, borderWidth: 1
				, stack: 2
				, order: 1
			}
			,{
				label: 'Check-In'
				, data: DataTemp.map( Value => Value.Actual )
				, backgroundColor: '#6A6A6A'
				, borderColor: '#6A6A6A'
				, hoverBackgroundColor: 'rgba(212, 212, 212, 0.88)'
				, hoverBorderColor: 'rgba(212, 212, 212, 0.88)'
				, borderWidth: 1
				, stack: 3
				, order: 1
			}
			,{
				label: 'No-Show'
				, data: DataTemp.map( Value => Value.NoShow )
				, backgroundColor: 'rgba(236, 55, 55, 0.88)'
				, borderColor: 'rgba(236, 55, 55, 0.88)'
				, hoverBackgroundColor: 'rgba(253, 137, 137, 0.88)'
				, hoverBorderColor: 'rgba(253, 137, 137, 0.88)'
				, borderWidth: 1
				, stack: 3
				, order: 1
			}
			,{
				label: 'Cancel'
				, data: DataTemp.map( Value => Value.Cancel )
				, backgroundColor: 'rgb(255, 232, 27)'
				, borderColor: 'rgb(255, 232, 27)'
				, hoverBackgroundColor: 'rgba(238, 236, 106, 0.88)'
				, hoverBorderColor: 'rgba(238, 236, 106, 0.88)'
				, borderWidth: 1
				, stack: 3
				, order: 1
			},{
				label: 'Reschedule'
				, data: DataTemp.map( Value => Value.Reschedule )
				, backgroundColor: 'rgba(0, 247, 255, 0.95)'
				, borderColor: 'rgba(0, 247, 255, 0.95)'
				, hoverBackgroundColor: 'rgba(141, 251, 255, 0.95)'
				, hoverBorderColor: 'rgba(141, 251, 255, 0.95)'
				, borderWidth: 1
				, stack: 3
				, order: 1
			}
		]
	}

	let ChartOption = {
		maintainAspectRatio: false
		, responsive : true
		, indexAxis: 'x'
		, scales: {
			x: {
				beginAtZero: true,
			},
			y: {
				beginAtZero: true,
			},
		}
		, plugins: {
			legend: {
				display: true
				, position: 'top'
				, align: 'center'
				, labels: {
					boxHeight: 10
					, boxWidth: 10
					, textAlign: 'left'
				}
			}
			, tooltip: {
				callbacks: {
					title: function(tooltipItem, data) {
						return ''
					}
				}
			}
			, datalabels: {
				display: true
				, align: 'center'
				, anchor: 'left'
				, color: function(context) {
					const bgColors = context.dataset.backgroundColor;
					let color = Array.isArray(bgColors) ? bgColors[context.dataIndex] : bgColors;

					if (!color) return '#000000';

					let hex = color.replace('#', '');

					if (hex.length === 3) {
					hex = hex.split('').map(char => char + char).join('');
					}

					let r, g, b;
					if (color.startsWith('rgb')) {
						const match = color.match(/\d+/g);
						r = parseInt(match[0]);
						g = parseInt(match[1]);
						b = parseInt(match[2]);
					} else {
						r = parseInt(hex.substring(0, 2), 16);
						g = parseInt(hex.substring(2, 4), 16);
						b = parseInt(hex.substring(4, 6), 16);
					}

					const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

					return yiq > 128 ? '#222222' : '#FFFFFF';
				}
				, font: {
					size: 10
				}
			}
		}
		, onHover: (e, ChartElement) => {
			e.native.target.style.cursor = ChartElement[0] ? 'pointer' : 'default'
		},
	}

	useEffect(() => {
		GetBookingVsDepositData()
	},[])

	return (
		<div className="col-12 col-lg-12">
			<div className="card bg-gradient-light">
				<div className="card-header">
					<h3 className="card-title text-success font-weight-bold">
						BOOKING VS DEPOSIT
					</h3>
					<div className="card-tools">
						<ul className="nav nav-pills ml-auto">
							<li className="nav-item text-info font-weight-bold">
							</li>
						</ul>
					</div>
				</div>
				<div className="CardBody-Chart">
					<div className="tab-content p-0">
						{
							Loading ?
								<div className="d-flex justify-content-center">
									<i className="fas fa-3x fa-sync-alt fa-spin"/>
								</div>
							:
								<div className="Chart-Container">
									<Bar
										data={ChartData}
										plugins={[ChartDataLabels]}
										options={ChartOption}
										height={null}
										width={null}
									/>
								</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default BookingVsDeposit